export const getGroupLevelAmountsExcelData = (excelData) => {
  return [
    [],
    ["", "Interest Restriction Return Page 4"],
    [],
    [
      "",
      "Group level amounts required in statement of calculations (Full return)",
    ],
    [],
    ["", "Fields below copy from p1"],
    excelData.gla_Row7,
    excelData.gla_Row8,
    excelData.gla_Row9,
    excelData.gla_Row10,
    [],
    ["", "For glossary of terms see end of CFM guidance after CFM99110"],
    ["", "For guidance on core CIR rules see CFM95200"],
    [],
    ["", "Statement of Calculations", "Full return only"],
    [],
    excelData.gla_Row17,
    excelData.gla_Row18,
    excelData.gla_Row19,
    excelData.gla_Row20,
    [],
    excelData.gla_Row22,
    excelData.gla_Row23,
    excelData.gla_Row24,
    excelData.gla_Row25,
    excelData.gla_Row26,
    excelData.gla_Row27,
    [],
    excelData.gla_Row29,
    [],
    excelData.gla_Row31,
    excelData.gla_Row32,
    excelData.gla_Row33,
    excelData.gla_Row34,
    [],
    ["", "Key"],
    ["", "Descriptive field or date", "Numerical entry, £"],
    ["", "Note"],
  ];
};
